
<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        <div class="form-title-img" />Para completar tu solicitud por favor completa estos datos:
      </div>
      <div class="form-components scroll">
        <div class="form__field">
          <label for="username">
            <v-icon
              name="user"
              scale="1"
            />
          </label>
          <input
            id="username"
            ref="username"
            v-model="usuarioNombre"
            autocomplete="off"
            type="text"
            name="username"
            value
            placeholder="Nombre"
            required
            @keyup.enter="focusTo('pass')"
          >
        </div>
        <div class="form__field">
          <label for="pass">
            <v-icon
              name="comment-dots"
              scale="1"
            />
          </label>
          <input
            id="pass"
            ref="pass"
            v-model="usuariopass"
            autocomplete="off"
            type="password"
            name="pass"
            value
            placeholder="Clave"
            required
            @keyup.enter="_sentClick"
          >
        </div>
        <!-- TODO: Parametrizar campos -->
        <!--
          <div class="form__field">
            <label for="password"><v-icon name="lock" scale="1" /></label>
            <input autocomplete="off" ref="password" id="password" type="password" name="password"  value="" v-model="usuarioPassword" @focus="_clearError"  @keyup.enter="_sentClick" placeholder="pass" required>
          </div>
        -->
        <div class="form-box-button scroll margin_btn">
          <template v-if="omitir != true">
            <button
              class="button-secondary"
              @click="_cancelClick"
            >
              Cancelar
            </button>
          </template>
          <button
            class="button-primary"
            @click="_sentClick"
          >
            Aceptar
          </button>
        </div>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/lock'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {
    cssStyle: {
      type: Object
    }
  },
  data () {
    return {
      usuarioNombre: '',
      usuariopass: '',
      usuarioRut: '',
      usuarioPassword: '',
      errormsg: '',
      omitir: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', e => {
      if (e.form !== 'Login') return
      // if (e.evento === 'init') {}
      if (e.evento === 'newdata') {
        this.omitir = e.dato.requerido
      }
    })
  },
  methods: {
    _formatearRut (val) {
      this.usuarioRut = utils.cleanSpecialChars(val, 'rut')
      this.usuarioRut = utils.formatearRut(this.usuarioRut)
    },
    _clearError () {
      this.errormsg = ''
    },
    keyPressCheckSpecialChars (evt, type) {
      if (type === 'rut') {
        evt = evt || window.event
        const strCompare = evt.key
        if (
          (this.usuarioRut + strCompare).toUpperCase().split('K').length - 1 >
          1
        ) {
          return evt.preventDefault()
        }
        if ((this.usuarioRut + strCompare).length > 13) {
          return evt.preventDefault()
        }
      }
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    focusTo (el) {
      if (el === 'pass') this.$refs.password.focus()
    },
    _sentClick () {
      this.errormsg = ''
      if (this.usuarioNombre === '') {
        this.$refs.username.focus()
        this.errormsg = 'Debe ingregar un nombre'
        return
      }
      if (this.usuariopass === '') {
        this.$refs.username.focus()
        this.errormsg = 'Debe ingregar una clave'
        return
      }
      /*
      if (!utils.isEpass(this.usuariopass)) {
        this.$refs.username.focus();
        this.errormsg = "Debe ingregar un pass válido";
        return;
      }
      */

      /* Por ahora solo valida nombre */
      /*
      if (!utils.validaRut(this.usuarioRut)) {
        this.$refs.username.focus();
        this.errormsg = 'Debe ingregar RUT válido';
        return;
      }
      if (this.usuarioPassword == '') {
        this.$refs.password.focus();
        this.errormsg = 'Debe ingresar clave de internet';
        return;
      }
      if (this.usuarioPassword.length>8) {
        this.$refs.password.focus();
        this.errormsg = 'Clave excede largo permitido';
        return;
      }
      if (this.usuarioPassword.length<4) {
        this.$refs.password.focus();
        this.errormsg = 'Clave largo no permitido';
        return;
      }
      */
      const dataToSend = {
        form: 'AlviLoginForm',
        evento: 'sentClick',
        data: {
          usuario_nombre: this.usuarioNombre,
          usuario_pass: this.usuariopass
        }
      }
      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'AlviLoginForm',
        evento: 'cancelClick',
        dato: 'CANCELANDO'
      })
    }
  }
}
</script>
<style lang="scss">

</style>
